import CONSTANTS from '../CONSTANTS';

const initialState = {
  patients: [],
  editData: {},
};

const usersPatientsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.USERS_PATIENTS_SET_LIST:
        return { ...state, patients: action.patients };
    case CONSTANTS.USERS_PATIENT_SET_EDIT_DATA:
        return { ...state, editData: action.data };
    default:
      return state;
  }
};

export default usersPatientsReducer;
